// src/pages/HomePage.jsx - GÜNCELLENMİŞ VERSİYON
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import {
  ChevronLeft, ChevronRight, TrendingUp, Zap, Package, Phone,
  Tag, Calendar, Clock, DollarSign, Gift, Heart, Award, Infinity
} from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useWishlist } from '../context/WishlistContext';
import { useSearch } from '../context/SearchContext';
import { openCartSidebar } from '../components/CartSidebar';
import ProductCard from '../components/ProductCard';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { getAvailableProducts } from '../services/productService';
import { getAllCampaigns, getFreeShippingCampaign } from '../services/discountService';
import {
  CATEGORY_CONFIG,
  getCategoryInfo
} from '../config/categoryConfig';
import toast from 'react-hot-toast';

export default function HomePage() {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [products, setProducts] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [availableCategories, setAvailableCategories] = useState([]);
  const [freeShippingCampaign, setFreeShippingCampaign] = useState(null);

  const { cartCount } = useCart();
  const { wishlistCount } = useWishlist();
  const { searchQuery, setSearchQuery } = useSearch();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [productsResult, campaignsResult, freeShippingResult] = await Promise.all([
          getAvailableProducts(),
          getAllCampaigns(),
          getFreeShippingCampaign()
        ]);

        if (productsResult.success) {
          const activeProducts = productsResult.products.filter(product =>
            product.isActive !== false
          );
          const productsWithCampaigns = activeProducts.filter(p => p.campaignId);
  console.log('🎯 Kampanyalı ürün sayısı:', productsWithCampaigns.length);
  console.log('🎯 Kampanyalı ürünler:', productsWithCampaigns.map(p => ({
    name: p.name,
    campaignId: p.campaignId,
    campaignTitle: p.campaignTitle,
    discount: p.discount
  })));
          console.log('Toplam ürün:', productsResult.products.length);
          console.log('Aktif ürün:', activeProducts.length);
          setProducts(activeProducts);

          // Mevcut kategorileri tespit et
          const categoriesSet = new Set();
          activeProducts.forEach(product => {
            if (product.category) {
              const mainCat = product.category.includes(' > ')
                ? product.category.split(' > ')[0]
                : product.category;
              categoriesSet.add(mainCat);
            }
          });
          setAvailableCategories(Array.from(categoriesSet));
        } else {
          toast.error('Ürünler yüklenirken hata oluştu');
        }

        if (campaignsResult.success) {
          // ✅ Kampanya filtreleme - SÜRESIZ KAMPANYALARI DAHIL ET
          const activeCampaigns = campaignsResult.campaigns.filter(campaign => {
            return isCampaignActive(campaign); // ✅ Yeni fonksiyon kullan
          });
          console.log('Aktif kampanyalar:', activeCampaigns);
          setCampaigns(activeCampaigns);
        }

        if (freeShippingResult.success && freeShippingResult.campaign) {
          setFreeShippingCampaign(freeShippingResult.campaign);
        }

      } catch (error) {
        console.error('Veri yükleme hatası:', error);
        toast.error('Bağlantı hatası');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // ÖNE ÇIKAN ÜRÜNLER
  const featuredProducts = useMemo(() => {
    return products
      .filter(p => p.isFeatured === true)
      .sort((a, b) => {
        const dateA = a.createdAt ? new Date(a.createdAt) : new Date(0);
        const dateB = b.createdAt ? new Date(b.createdAt) : new Date(0);
        return dateB - dateA;
      })
      .slice(0, 8);
  }, [products]);

  // Popüler Ürünler
  const popularProducts = useMemo(() => {
    return products
      .filter(p => (p.likes || 0) > 0)
      .sort((a, b) => (b.likes || 0) - (a.likes || 0))
      .slice(0, 10);
  }, [products]);

  // En Çok Satanlar
  const bestSellers = useMemo(() => {
    return products
      .filter(p => (p.sales || 0) > 0)
      .sort((a, b) => (b.sales || 0) - (a.sales || 0))
      .slice(0, 10);
  }, [products]);

  // Yeni Ürünler - SON 20 GÜN İÇİNDE EKLENENLER
  const newProducts = useMemo(() => {
    const twentyDaysAgo = new Date();
    twentyDaysAgo.setDate(twentyDaysAgo.getDate() - 20);

    return products
      .filter(product => {
        if (!product.createdAt) return false;

        const createdDate = product.createdAt.toDate
          ? product.createdAt.toDate()
          : new Date(product.createdAt);

        return createdDate >= twentyDaysAgo;
      })
      .sort((a, b) => {
        const dateA = a.createdAt?.toDate ? a.createdAt.toDate() : new Date(a.createdAt || 0);
        const dateB = b.createdAt?.toDate ? b.createdAt.toDate() : new Date(b.createdAt || 0);
        return dateB - dateA;
      })
      .slice(0, 10);
  }, [products]);

  // İndirimli Ürünler
  const discountedProducts = useMemo(() => {
    return products.filter(p => {
      if (p.discountType && p.discountType !== 'none' && p.discountValue > 0) {
        return true;
      }
      if (p.originalPrice && p.currentPrice && p.originalPrice > p.currentPrice) {
        return true;
      }
      if (p.discount && p.discount > 0) {
        return true;
      }
      return false;
    }).slice(0, 8);
  }, [products]);

  const isCampaignActive = (campaign) => {
    // Eğer endDate null, undefined, 'null' string ise → Süresiz kampanya
    if (!campaign.endDate || campaign.endDate === 'null' || campaign.endDate === null) {
      return true;
    }
    // Tarih kontrolü
    return new Date(campaign.endDate) > new Date();
  };

  // Kampanyalı Ürünler
  const campaignProducts = useMemo(() => {
    if (campaigns.length === 0) return [];

    const activeCampaigns = campaigns.filter(c => new Date(c.endDate) > new Date());
    if (activeCampaigns.length === 0) return [];

    const campaignedProducts = products.filter(product => {
      return activeCampaigns.some(campaign => {
        if (campaign.targetCategory && campaign.targetCategory !== '') {
          return product.category === campaign.targetCategory;
        }
        return true;
      });
    });

    return campaignedProducts.slice(0, 8);
  }, [products, campaigns]);

  // Önerilen Ürünler
  const recommendedProducts = useMemo(() => {
    return products
      .filter(p => (p.sales || 0) === 0)
      .sort((a, b) => {
        const dateA = a.createdAt ? new Date(a.createdAt) : new Date(0);
        const dateB = b.createdAt ? new Date(b.createdAt) : new Date(0);
        return dateB - dateA;
      })
      .slice(0, 8);
  }, [products]);

  // ✨ TRONA MARKASI ÜRÜNLERİ
  const tronaProducts = useMemo(() => {
    return products
      .filter(p => p.brand && p.brand.toLowerCase() === 'trona')
      .sort((a, b) => {
        const scoreA = (a.sales || 0) * 2 + (a.likes || 0) * 1.5;
        const scoreB = (b.sales || 0) * 2 + (b.likes || 0) * 1.5;
        return scoreB - scoreA;
      })
      .slice(0, 8);
  }, [products]);

  // Çok Satan Kategoriler
  const topCategoryProducts = useMemo(() => {
    const categoryMap = new Map();

    products.forEach(product => {
      if (!product.category) return;

      if (!categoryMap.has(product.category)) {
        categoryMap.set(product.category, []);
      }
      categoryMap.get(product.category).push(product);
    });

    const topProducts = [];
    categoryMap.forEach((categoryProducts) => {
      const sorted = categoryProducts.sort((a, b) => {
        const scoreA = (a.sales || 0) * 2 + (a.likes || 0);
        const scoreB = (b.sales || 0) * 2 + (b.likes || 0);
        return scoreB - scoreA;
      });
      topProducts.push(...sorted.slice(0, 2));
    });
    return topProducts.slice(0, 10);
  }, [products]);

  // KATEGORİYE GÖRE GRUPLA
  const productsByMainCategory = useMemo(() => {
    const grouped = {};

    products.forEach(product => {
      if (!product.category) return;

      const mainCat = product.category.includes(' > ')
        ? product.category.split(' > ')[0]
        : product.category;

      if (!grouped[mainCat]) {
        grouped[mainCat] = [];
      }
      grouped[mainCat].push(product);
    });

    Object.keys(grouped).forEach(cat => {
      grouped[cat].sort((a, b) => {
        const scoreA = (a.sales || 0) * 2 + (a.likes || 0) * 1.5 + (a.views || 0) * 0.3;
        const scoreB = (b.sales || 0) * 2 + (b.likes || 0) * 1.5 + (b.views || 0) * 0.3;
        return scoreB - scoreA;
      });
    });

    return grouped;
  }, [products]);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  return (
    <div className="homepage">
      <Style />

      <Header
        wishlistCount={wishlistCount}
        cartCount={cartCount}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        onSearch={handleSearch}
        onCartClick={openCartSidebar}
        onWishlistClick={() => navigate('/wishlist')}
        onCampaignsClick={() => navigate('/campaigns')}
        availableCategories={availableCategories}
        products={products}
      />

      <HeroSlider
        currentSlide={currentSlide}
        setCurrentSlide={setCurrentSlide}
        campaigns={campaigns}
        freeShippingCampaign={freeShippingCampaign}
        navigate={navigate}
      />

      <CategoryBar
        availableCategories={availableCategories}
      />

      <main className="main-content">
        <Features />

        {loading ? (
          <div className="loading-state">
            <div className="spinner"></div>
            <p>Ürünler yükleniyor...</p>
          </div>
        ) : (
          <>
            {/* ÖNE ÇIKAN ÜRÜNLER */}
            {featuredProducts.length > 0 && (
              <ProductSection
                title="⭐ Öne Çıkan Ürünler"
                subtitle="Sizin için özenle seçtiklerimiz"
                products={featuredProducts}
                campaigns={campaigns}
                filterType="featured"
                highlight
              />
            )}

            {/* POPÜLER ÜRÜNLER */}
            {popularProducts.length > 0 && (
              <ProductSection
                title="💎 Popüler Ürünler"
                subtitle="En çok ilgi gören ürünler"
                products={popularProducts}
                campaigns={campaigns}
                filterType="popular"
              />
            )}

            {/* KAMPANYALAR */}
            {campaigns.length > 0 && (
              <CombinedOffersSection
                campaigns={campaigns}
              />
            )}

            {/* İNDİRİMLİ ÜRÜNLER */}
            {discountedProducts.length > 0 && (
              <ProductSection
                title="⚡ Bugünün Fırsatları"
                subtitle="Kaçırılmayacak indirimler"
                products={discountedProducts}
                campaigns={campaigns}
                filterType="discounted"
                highlight
              />
            )}

            {/* ✨ TRONA MARKASI ÜRÜNLERİ */}
            {tronaProducts.length > 0 && (
              <ProductSection
                title="🏅 Trona Ürünleri"
                subtitle="Kalite ve güvenin adresi"
                products={tronaProducts}
                campaigns={campaigns}
                filterType="brand"
                icon={<Award size={32} />}
                brandHighlight
              />
            )}

            {/* KAMPANYALI ÜRÜNLER */}
            {campaignProducts.length > 0 && (
              <ProductSection
                title="🏷️ Kampanyalı Ürünler"
                subtitle="Aktif kampanyalardan yararlanabileceğiniz ürünler"
                products={campaignProducts}
                campaigns={campaigns}
                filterType="campaign"
              />
            )}

            {/* YENİ ÜRÜNLER */}
            {newProducts.length > 0 && (
              <ProductSection
                title="🆕 Yeni Ürünler"
                subtitle="Yeni eklenen taze ürünler"
                products={newProducts}
                campaigns={campaigns}
                filterType="new"
              />
            )}

            {/* EN ÇOK SATANLAR */}
            {bestSellers.length > 0 && (
              bestSellers.some(p => (p.sales || 0) > 0) ? (
                <ProductSection
                  title="🏆 En Çok Satanlar"
                  subtitle="Müşterilerimizin favorileri"
                  products={bestSellers}
                  campaigns={campaigns}
                  filterType="bestsellers"
                />
              ) : (
                <ProductSection
                  title="✨ Sizin İçin Seçtiklerimiz"
                  subtitle="Keşfetmenizi önerdiğimiz ürünler"
                  products={recommendedProducts.length > 0 ? recommendedProducts : bestSellers}
                  campaigns={campaigns}
                  filterType="recommended"
                />
              )
            )}

            <BannerPromo campaigns={campaigns} />

            {/* KATEGORİ BAZLI ÜRÜN LİSTELEME */}
            {Object.entries(productsByMainCategory)
              .filter(([cat, prods]) => prods.length >= 4)
              .sort((a, b) => b[1].length - a[1].length)
              .slice(0, 6)
              .map(([categoryName, categoryProducts]) => {
                const categoryInfo = getCategoryInfo(categoryName);
                return (
                  <ProductSection
                    key={categoryName}
                    title={`${categoryInfo.emoji} ${categoryName}`}
                    subtitle={`${categoryProducts.length} ürün`}
                    products={categoryProducts.slice(0, 8)}
                    campaigns={campaigns}
                    filterType="category"
                    categoryLink={`/category/${encodeURIComponent(categoryName)}`}
                  />
                );
              })
            }

            {/* KATEGORİLERİN EN İYİLERİ */}
            {topCategoryProducts.length > 0 && (
              <ProductSection
                title="🔥 Kategorilerin En İyileri"
                subtitle="Her kategoriden öne çıkan ürünler"
                products={topCategoryProducts}
                campaigns={campaigns}
                filterType="topCategory"
              />
            )}

            {/* TÜM ÜRÜNLER */}
            {products.length > 12 && (
              <ProductSection
                title="🛒 Tüm Ürünler"
                subtitle="Geniş ürün yelpazemizi keşfedin"
                products={products.slice(0, 16)}
                campaigns={campaigns}
                filterType="all"
              />
            )}
          </>
        )}
      </main>
      <Footer />
    </div>
  );
}

// ==================== KATEGORİ BAR ====================
function CategoryBar({ availableCategories }) {
  const visibleCategories = availableCategories
    .filter(cat => CATEGORY_CONFIG[cat])
    .slice(0, 9);

  return (
    <div className="category-bar">
      <div className="container">
        <div className="categories-scroll">
          {visibleCategories.map((catName) => {
            const catConfig = CATEGORY_CONFIG[catName];
            return (
              <Link
                key={catName}
                to={`/category/${catName}`}
                className="category-item"
              >
                <span className="cat-icon" style={{ background: getCategoryColor(catName) }}>
                  {catConfig.emoji}
                </span>
                <span className="cat-name">{catName}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}

function getCategoryColor(categoryName) {
  const colors = {
    'Gıda & İçecek': '#ff6b6b',
    'Ev & Mutfak': '#4ecdc4',
    'Kişisel Bakım': '#9b59b6',
    'Elektronik': '#3498db',
    'Hobi & Yaşam': '#f39c12',
    'Bebek & Çocuk': '#e91e63',
    'Giyim & Aksesuar': '#2ecc71',
    'Evcil Hayvan': '#8b4513'
  };
  return colors[categoryName] || '#95a5a6';
}

// ==================== DİĞER BİLEŞENLER ====================

function CombinedOffersSection({ campaigns }) {
  const allOffers = [
    ...campaigns.map(c => ({ ...c, type: "campaign" })),
  ];

  return (
    <section className="combined-offers-section">
      <div className="container">
        <div className="section-header">
          <div>
            <h2>🎉 Aktif Fırsatlar</h2>
            <p>Kampanyalar</p>
          </div>

          <Link to="/campaigns" className="view-all">
            Tümünü Gör →
          </Link>
        </div>

        <div className="offers-grid">
          {allOffers.slice(0, 6).map((offer) => (
            offer.type === "campaign" && (
              <CampaignCard
                key={`campaign-${offer.id}`}
                campaign={offer}
              />
            )
          ))}
        </div>
      </div>
    </section>
  );
}

function CampaignCard({ campaign }) {
  // ✅ Süresiz kampanya kontrolü
  const isUnlimited = !campaign.endDate || campaign.endDate === 'null' || campaign.endDate === null;
  const isActive = isUnlimited ? true : new Date(campaign.endDate) > new Date();

  const daysLeft = isUnlimited
    ? null
    : Math.ceil((new Date(campaign.endDate) - new Date()) / (1000 * 60 * 60 * 24));

  return (
    <Link to="/search?filter=campaign" className="offer-card campaign-type">
      <div className="offer-badge campaign-badge">
        <Tag size={16} />
        %{campaign.discountPercent}
      </div>
      <div className="offer-content">
        <div className="offer-icon campaign-icon">
          <Tag size={28} />
        </div>
        <h3>{campaign.title}</h3>
        <p>{campaign.description}</p>
        <div className="offer-details">
          {campaign.targetCategory && (
            <span className="offer-detail">
              <Package size={14} />
              {campaign.targetCategory}
            </span>
          )}
          {/* ✅ Süresiz kampanyalarda farklı görünüm */}
          {isActive && (
            <span className="offer-detail time">
              <Calendar size={14} />
              {isUnlimited ? 'Süresiz' : `${daysLeft} gün kaldı`}
            </span>
          )}
        </div>
        {campaign.minPurchase > 0 && (
          <div className="offer-min">
            Min. {campaign.minPurchase}₺ alışveriş
          </div>
        )}
      </div>
    </Link>
  );
}

function ProductSection({ title, subtitle, products, highlight, campaigns = [], filterType, categoryLink, icon, brandHighlight }) {
  const scrollContainerRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const checkScroll = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 10);
    }
  };

  useEffect(() => {
    checkScroll();
    const container = scrollContainerRef.current;
    if (container) {
      container.addEventListener('scroll', checkScroll);
      return () => container.removeEventListener('scroll', checkScroll);
    }
  }, [products]);

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = direction === 'left' ? -400 : 400;
      scrollContainerRef.current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  const viewAllLink = categoryLink || `/search?filter=${filterType}`;

  return (
    <section className={`product-section ${highlight ? 'highlight' : ''} ${brandHighlight ? 'brand-highlight' : ''}`}>
      <div className="container">
        <div className="section-header">
          <div className="section-title-with-icon">
            {icon && <div className="section-icon">{icon}</div>}
            <div>
              <h2>{title}</h2>
              <p>{subtitle}</p>
            </div>
          </div>
          <Link to={viewAllLink} className="view-all">
            Tümünü Gör →
          </Link>
        </div>

        <div className="products-carousel-wrapper">
          {canScrollLeft && (
            <button
              className="carousel-nav-btn left"
              onClick={() => scroll('left')}
              aria-label="Önceki ürünler"
            >
              <ChevronLeft size={24} />
            </button>
          )}

          <div className="products-carousel" ref={scrollContainerRef}>
            {products.map(product => (
              <div key={product.id} className="product-carousel-item">
                <ProductCard
                  product={product}
                  campaigns={campaigns}
                />
              </div>
            ))}
          </div>

          {canScrollRight && (
            <button
              className="carousel-nav-btn right"
              onClick={() => scroll('right')}
              aria-label="Sonraki ürünler"
            >
              <ChevronRight size={24} />
            </button>
          )}
        </div>
      </div>
    </section>
  );
}

// HomePage.jsx içinde HeroSlider component - DÜZELTİLMİŞ VERSİYON

function HeroSlider({ currentSlide, setCurrentSlide, campaigns, freeShippingCampaign, navigate }) {
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [isSwiping, setIsSwiping] = useState(false);

  // ✅ KAMPANYA SLIDE'LARI - Sadece discount olanlar
  const campaignSlides = campaigns
    .filter(c => c.discountType === 'discount')
    .map(campaign => ({
      title: campaign.title,
      subtitle: campaign.description,
      cta: "Kampanyayı İncele",
      bg: "linear-gradient(135deg, #E5332A 0%, #c72a22 100%)",
      discount: campaign.discountPercent,
      type: 'campaign',
      isUnlimited: !campaign.endDate || campaign.endDate === 'null' || campaign.endDate === null
    }));

  // ✅ FREE SHIPPING SLIDE - BASIT KONTROL
  const freeShippingSlide = freeShippingCampaign ? [{
    title: freeShippingCampaign.title || `${freeShippingCampaign.freeShippingThreshold}₺ Üzeri Kargo Bedava`,
    subtitle: freeShippingCampaign.description || "Ücretsiz teslimat ile alışverişin keyfini çıkarın",
    cta: "Alışverişe Başla",
    bg: "linear-gradient(135deg, #06d6a0 0%, #04b87c 100%)",
    icon: <Package size={48} />,
    type: 'shipping',
    threshold: freeShippingCampaign.freeShippingThreshold,
    isUnlimited: !freeShippingCampaign.endDate || 
                 freeShippingCampaign.endDate === 'null' || 
                 freeShippingCampaign.endDate === null
  }] : [];

  const defaultSlides = [{
    title: "Alışverişin Keyfini Çıkarın",
    subtitle: "Kaliteli ürünler, uygun fiyatlar",
    cta: "Alışverişe Başla",
    bg: "linear-gradient(135deg, #2B2B2B 0%, #1a1a1a 100%)",
    type: 'default'
  }];

  const slides = [...freeShippingSlide, ...campaignSlides, ...defaultSlides];
  const showControls = slides.length > 1;

  // ✅ DEBUG LOGLARI
  console.log('🎬 HeroSlider render:', {
    freeShippingCampaign: freeShippingCampaign,
    freeShippingSlideLength: freeShippingSlide.length,
    campaignSlidesLength: campaignSlides.length,
    totalSlides: slides.length,
    slides: slides.map(s => ({ type: s.type, title: s.title }))
  });

  // Otomatik geçiş
  useEffect(() => {
    if (showControls && !isDragging) {
      const timer = setInterval(() => setCurrentSlide((prev) => (prev + 1) % slides.length), 5000);
      return () => clearInterval(timer);
    }
  }, [slides.length, showControls, setCurrentSlide, isDragging]);

  // Touch events
  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(0);
    setTouchStart(e.targetTouches[0].clientX);
    setIsDragging(true);
    setIsSwiping(false);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
    if (Math.abs(e.targetTouches[0].clientX - touchStart) > 10) {
      setIsSwiping(true);
    }
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) {
      setIsDragging(false);
      setIsSwiping(false);
      return;
    }
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    } else if (isRightSwipe) {
      setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
    }

    setTimeout(() => {
      setIsDragging(false);
      setIsSwiping(false);
    }, 100);
  };

  const onMouseDown = (e) => {
    setTouchEnd(0);
    setTouchStart(e.clientX);
    setIsDragging(true);
    setIsSwiping(false);
  };

  const onMouseMove = (e) => {
    if (isDragging) {
      setTouchEnd(e.clientX);
      if (Math.abs(e.clientX - touchStart) > 10) {
        setIsSwiping(true);
      }
    }
  };

  const onMouseUp = () => {
    if (!touchStart || !touchEnd) {
      setIsDragging(false);
      setIsSwiping(false);
      return;
    }
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    } else if (isRightSwipe) {
      setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
    }

    setTimeout(() => {
      setIsDragging(false);
      setIsSwiping(false);
    }, 100);
  };

  const onMouseLeave = () => {
    if (isDragging) {
      setIsDragging(false);
      setIsSwiping(false);
    }
  };

  const handleSlideClick = (e, slideType) => {
    if (isSwiping) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    
    if (slideType === 'campaign') {
      navigate('/campaigns');
    } else if (slideType === 'shipping' || slideType === 'default') {
      navigate('/search');
    } else {
      navigate('/search?filter=offers');
    }
  };

  return (
    <div 
      className="hero-slider"
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
      onMouseDown={onMouseDown}
      onMouseMove={onMouseMove}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseLeave}
    >
      <div className="slides" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
        {slides.map((slide, idx) => (
          <div key={idx} className="slide" style={{ background: slide.bg }}>
            <div className="container">
              <div className="slide-content">
                {/* İkon (kargo için) */}
                {slide.icon && <div className="slide-icon">{slide.icon}</div>}
                
                {/* İndirim badge */}
                {slide.discount && (
                  <div className="slide-discount-container">
                    <div className="slide-discount">%{slide.discount} İNDİRİM</div>
                    {slide.isUnlimited && (
                      <div className="slide-unlimited-badge">
                        <Infinity size={16} />
                        <span>Süresiz</span>
                      </div>
                    )}
                  </div>
                )}
                
                {/* Threshold (kargo için) */}
                {slide.threshold && (
                  <div className="slide-threshold-container">
                    <div className="slide-threshold">
                      {slide.threshold}₺ ve üzeri
                    </div>
                    {slide.isUnlimited && (
                      <div className="slide-unlimited-badge">
                        <Infinity size={16} />
                        <span>Süresiz</span>
                      </div>
                    )}
                  </div>
                )}
                
                <h1>{slide.title}</h1>
                <p>{slide.subtitle}</p>
                
                <button
                  className="cta-btn"
                  onClick={(e) => handleSlideClick(e, slide.type)}
                  onTouchEnd={(e) => {
                    if (isSwiping) {
                      e.preventDefault();
                      e.stopPropagation();
                    }
                  }}
                >
                  {slide.cta}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {showControls && (
        <>
          <button
            className="slider-btn prev"
            onClick={() => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)}
            aria-label="Önceki slayt"
          >
            <ChevronLeft size={24} />
          </button>
          <button
            className="slider-btn next"
            onClick={() => setCurrentSlide((prev) => (prev + 1) % slides.length)}
            aria-label="Sonraki slayt"
          >
            <ChevronRight size={24} />
          </button>
          <div className="slider-dots">
            {slides.map((_, idx) => (
              <button
                key={idx}
                className={`dot ${idx === currentSlide ? 'active' : ''}`}
                onClick={() => setCurrentSlide(idx)}
                aria-label={`Slayt ${idx + 1}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}

function Features() {
  const features = [
    { icon: <Package size={32} />, title: 'Hızlı Teslimat', desc: 'Aynı gün kargo' },
    { icon: <Zap size={32} />, title: 'Güvenli Alışveriş', desc: '256-bit SSL' },
    { icon: <TrendingUp size={32} />, title: 'En İyi Fiyat', desc: 'Fiyat garantisi' },
    { icon: <Phone size={32} />, title: '7/24 Destek', desc: 'Müşteri hizmetleri' }
  ];
  return (
    <div className="features"><div className="container"><div className="features-grid">
      {features.map((f, i) => (<div key={i} className="feature-card"><div className="feature-icon">{f.icon}</div><div className="feature-text"><h4>{f.title}</h4><p>{f.desc}</p></div></div>))}
    </div></div></div>
  );
}

function BannerPromo({ campaigns }) {
  const isCampaignActive = (campaign) => {
    // Eğer endDate null, undefined, 'null' string ise → Süresiz kampanya
    if (!campaign.endDate || campaign.endDate === 'null' || campaign.endDate === null) {
      return true;
    }
    // Tarih kontrolü
    return new Date(campaign.endDate) > new Date();
  };

  const [currentIndex, setCurrentIndex] = useState(0);

  const allOffers = [
    ...campaigns.map(c => ({ ...c, type: 'campaign' })),
  ].filter(offer => {
    // ✅ Süresiz kampanyaları dahil et
    return isCampaignActive(offer);
  });

  useEffect(() => {
    if (allOffers.length > 1) {
      const timer = setInterval(() => {
        setCurrentIndex(prev => (prev + 1) % allOffers.length);
      }, 8000);
      return () => clearInterval(timer);
    }
  }, [allOffers.length]);

  if (allOffers.length === 0) {
    return (
      <div className="banner-promo">
        <div className="container">
          <div className="promo-content">
            <div className="promo-text">
              <h2>Özel Fırsatlar Sizi Bekliyor!</h2>
              <p>Yeni kampanyalarımızdan haberdar olmak için bizi takip edin</p>
              <Link to="/campaigns" className="cta-btn-link">
                <button className="cta-btn">
                  Kampanyaları İncele
                </button>
              </Link>
            </div>
            <div className="promo-image">
              <div className="promo-circle"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const currentOffer = allOffers[currentIndex];

  // ✅ Süresiz kampanya kontrolü
  const isUnlimited = !currentOffer.endDate ||
    currentOffer.endDate === 'null' ||
    currentOffer.endDate === null;

  const daysLeft = isUnlimited
    ? null
    : Math.ceil((new Date(currentOffer.endDate) - new Date()) / (1000 * 60 * 60 * 24));

  return (
    <div className="banner-promo">
      <div className="container">
        <div className="promo-content">
          <div className="promo-text">
            <h2>{currentOffer.title}</h2>
            <p>{currentOffer.description}</p>
            <div className="promo-details">
              {currentOffer.targetCategory && (
                <span className="promo-detail">
                  <Package size={16} />
                  {currentOffer.targetCategory}
                </span>
              )}
              {/* ✅ Süresiz kampanyalarda farklı görünüm */}
              <span className="promo-detail">
                <Clock size={16} />
                {isUnlimited ? 'Süresiz kampanya' : `${daysLeft} gün kaldı`}
              </span>
              {currentOffer.minPurchase > 0 && (
                <span className="promo-detail">
                  <DollarSign size={16} />
                  Min. {currentOffer.minPurchase}₺
                </span>
              )}
            </div>
            <Link to="/search?filter=offers" className="cta-btn-link">
              <button className="cta-btn">
                Fırsatı İncele
              </button>
            </Link>
            {allOffers.length > 1 && (
              <div className="campaign-dots">
                {allOffers.map((_, idx) => (
                  <button
                    key={idx}
                    className={`dot ${idx === currentIndex ? 'active' : ''}`}
                    onClick={() => setCurrentIndex(idx)}
                    aria-label={`Kampanya ${idx + 1}`}
                  />
                ))}
              </div>
            )}
          </div>
          <div className="promo-image">
            <div className="promo-circle" style={{
              background: 'linear-gradient(135deg, #E5332A, #ff4436)'
            }}></div>
            <div className="promo-icon">
              {currentOffer.type === 'promotion' ? <Gift size={80} /> : <Tag size={80} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Style() {
  return <style>{`
    * { margin: 0; padding: 0; box-sizing: border-box; -webkit-tap-highlight-color: transparent; }
    html { scroll-behavior: smooth; }
    body { font-family: 'Inter', -apple-system, sans-serif; background: #f8f9fa; color: #2B2B2B; }
    img { max-width: 100%; height: auto; }
    a { text-decoration: none; color: inherit; }
    .homepage { min-height: 100vh; }
    .container { max-width: 1320px; margin: 0 auto; padding: 0 20px; }
    
    .hero-slider { position: relative; height: 480px; overflow: hidden; background: #2B2B2B; touch-action: pan-y; user-select: none; -webkit-user-select: none; cursor: grab; }
    .hero-slider:active { cursor: grabbing; }
    .slides { display: flex; height: 100%; transition: transform 0.4s ease-out; will-change: transform; }
    .slide { min-width: 100%; height: 100%; display: flex; align-items: center; }
    .slide-content { max-width: 600px; color: #fff; }
    .slide-icon { font-size: 48px; margin-bottom: 16px; animation: bounce 2s infinite; }
    @keyframes bounce { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }
    .slide-discount-container {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.slide-discount { 
  display: inline-block; 
  background: rgba(255,255,255,0.2); 
  padding: 8px 16px; 
  border-radius: 8px; 
  font-size: 14px; 
  font-weight: 700; 
}

.slide-unlimited-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(6, 214, 160, 0.3);
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  border: 2px solid rgba(6, 214, 160, 0.6);
  backdrop-filter: blur(4px);
  margin-left: 16px;
}

.slide-unlimited-badge svg {
  animation: float 2s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-4px); }
}
    .slide-content h1 { font-size: 48px; font-weight: 800; margin-bottom: 16px; line-height: 1.1; }
    .slide-content p { font-size: 20px; margin-bottom: 32px; opacity: 0.9; }
    .slide-threshold {
  display: inline-block;
  background: rgba(255,255,255,0.2);
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 16px;
  border: 2px solid rgba(255,255,255,0.3);
}
    .cta-btn { background: #fff; color: #E5332A; border: none; padding: 16px 32px; border-radius: 12px; font-size: 16px; font-weight: 700; cursor: pointer; transition: transform 0.2s; }
    .cta-btn:active { transform: scale(0.97); }
    .cta-btn-link { display: inline-block; }
    .slider-btn { position: absolute; top: 50%; transform: translateY(-50%); background: rgba(255,255,255,0.9); border: none; width: 48px; height: 48px; border-radius: 50%; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: all 0.2s; z-index: 10; }
    .slider-btn:hover { background: #fff; }
    .slider-btn.prev { left: 24px; }
    .slider-btn.next { right: 24px; }
    .slider-dots { position: absolute; bottom: 24px; left: 50%; transform: translateX(-50%); display: flex; gap: 12px; z-index: 10; }
    .dot { width: 12px; height: 12px; border-radius: 50%; background: rgba(255,255,255,0.4); border: none; cursor: pointer; transition: all 0.3s; }
    .dot.active { background: #fff; width: 32px; border-radius: 6px; }
    
    .category-bar { background: #fff; padding: 24px 0; border-bottom: 1px solid #e9ecef; }
    .categories-scroll { display: flex; gap: 16px; overflow-x: auto; -webkit-overflow-scrolling: touch; scrollbar-width: none; -ms-overflow-style: none; }
    .categories-scroll::-webkit-scrollbar { display: none; }
    .category-item { display: flex; flex-direction: column; align-items: center; gap: 8px; background: none; border: none; cursor: pointer; padding: 12px 16px; border-radius: 12px; min-width: 100px; transition: all 0.2s; flex-shrink: 0; }
    .category-item:hover { background: #f8f9fa; }
    .category-item:active { transform: scale(0.95); }
    .cat-icon { width: 56px; height: 56px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 28px; }
    .cat-name { font-size: 13px; font-weight: 600; white-space: nowrap; }
    
    .main-content { padding: 40px 0; }
    .features { margin-bottom: 48px; }
    .features-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 24px; }
    .feature-card { background: #fff; padding: 24px; border-radius: 16px; display: flex; align-items: center; gap: 16px; box-shadow: 0 2px 8px rgba(0,0,0,0.04); }
    .feature-icon { width: 64px; height: 64px; background: linear-gradient(135deg, #E5332A, #ff4436); border-radius: 16px; display: flex; align-items: center; justify-content: center; color: #fff; flex-shrink: 0; }
    .feature-text h4 { font-size: 16px; font-weight: 700; margin-bottom: 4px; }
    .feature-text p { font-size: 13px; color: #868e96; }
    
    .combined-offers-section { margin-bottom: 56px; }
    .offers-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
    .offer-card { background: #fff; border-radius: 16px; padding: 24px; cursor: pointer; position: relative; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.04); transition: all 0.3s; border: 2px solid #e9ecef; display: block; }
    .offer-card:hover { transform: translateY(-4px); box-shadow: 0 12px 32px rgba(0,0,0,0.12); }
    .offer-card.campaign-type:hover { border-color: #E5332A; }
    .offer-badge { position: absolute; top: 16px; right: 16px; padding: 6px 12px; border-radius: 8px; font-size: 12px; font-weight: 700; display: flex; align-items: center; gap: 6px; }
    .campaign-badge { background: #E5332A; color: #fff; }
    .offer-icon { width: 64px; height: 64px; border-radius: 16px; display: flex; align-items: center; justify-content: center; color: #fff; margin-bottom: 16px; }
    .campaign-icon { background: linear-gradient(135deg, #E5332A, #ff4436); }
    .offer-content h3 { font-size: 20px; font-weight: 700; margin-bottom: 8px; color: #2B2B2B; }
    .offer-content p { color: #868e96; font-size: 14px; margin-bottom: 16px; line-height: 1.6; }
    .offer-details { display: flex; gap: 12px; flex-wrap: wrap; margin-bottom: 12px; }
    .offer-detail { display: flex; align-items: center; gap: 6px; font-size: 12px; color: #868e96; padding: 4px 10px; background: #f8f9fa; border-radius: 6px; }
    .offer-detail.time { color: #E5332A; background: #fff5f5; font-weight: 600; }
    .offer-min { font-size: 12px; color: #868e96; padding: 8px 12px; background: #f8f9fa; border-radius: 8px; display: inline-block; }
    
    .product-section { margin-bottom: 56px; }
    .product-section.highlight { background: linear-gradient(135deg, #fff5f5, #ffe8e8); padding: 48px 0; margin: 0 0 56px 0; }
    .product-section.brand-highlight { 
      background: linear-gradient(135deg, #f8f9ff, #e8f0ff); 
      padding: 48px 0; 
      margin: 0 0 56px 0;
    }
    .section-header { 
      display: flex; 
      justify-content: space-between; 
      align-items: center; 
      margin-bottom: 32px; 
      flex-wrap: wrap; 
      gap: 16px; 
    }
    .section-title-with-icon { display: flex; align-items: center; gap: 16px; flex: 1; }
    .section-icon { width: 56px; height: 56px; background: linear-gradient(135deg, #ff6b9d, #ffc3a0); border-radius: 16px; display: flex; align-items: center; justify-content: center; color: #fff; animation: pulse-icon 2s infinite; flex-shrink: 0; }
    @keyframes pulse-icon { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.05); } }
    .section-header h2 { font-size: 32px; font-weight: 800; }
    .section-header p { color: #868e96; font-size: 14px; }
    .view-all { 
      background: none; 
      border: 2px solid #e9ecef; 
      padding: 10px 20px; 
      border-radius: 10px; 
      font-weight: 600; 
      cursor: pointer; 
      transition: all 0.2s; 
      white-space: nowrap;
      flex-shrink: 0;
    }
    .view-all:hover { border-color: #E5332A; color: #E5332A; }
    
    .products-carousel-wrapper { position: relative; }
    
    .products-carousel {
      display: flex;
      gap: 20px;
      overflow-x: auto;
      overflow-y: hidden;
      scroll-behavior: smooth;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;
      -ms-overflow-style: none;
      padding: 4px 0;
    }
    
    .products-carousel::-webkit-scrollbar { display: none; }
    
    .product-carousel-item {
      flex: 0 0 auto;
      width: calc((100% - 80px) / 5);
      min-width: 220px;
    }
    
    .carousel-nav-btn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 48px;
      height: 48px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.95);
      border: 2px solid #e9ecef;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 10;
      transition: all 0.3s ease;
      box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    }
    
    .carousel-nav-btn:hover {
      background: #fff;
      border-color: #E5332A;
      box-shadow: 0 6px 20px rgba(229, 51, 42, 0.2);
    }
    
    .carousel-nav-btn:active {
      transform: translateY(-50%) scale(0.95);
    }
    
    .carousel-nav-btn.left {
      left: -24px;
    }
    
    .carousel-nav-btn.right {
      right: -24px;
    }
    
    .carousel-nav-btn svg {
      color: #2B2B2B;
      transition: color 0.3s ease;
    }
    
    .carousel-nav-btn:hover svg {
      color: #E5332A;
    }

    .product-card { background: #fff; border-radius: 12px; overflow: hidden; position: relative; cursor: pointer; box-shadow: 0 2px 8px rgba(0,0,0,0.04); transition: all 0.3s; height: 100%; display: flex; flex-direction: column; }
    .product-card:hover { transform: translateY(-4px); box-shadow: 0 8px 24px rgba(0,0,0,0.1); }
    .product-carousel-item { height: 380px; }
    .discount-badge { position: absolute; top: 8px; left: 8px; background: #E5332A; color: #fff; padding: 4px 10px; border-radius: 6px; font-size: 11px; font-weight: 700; z-index: 2; display: flex; align-items: center; gap: 3px; }
    .campaign-indicator { font-size: 10px; animation: bounce 1s infinite; }
    .wishlist-btn { position: absolute; top: 8px; right: 8px; width: 32px; height: 32px; background: rgba(255,255,255,0.9); border: none; border-radius: 50%; cursor: pointer; display: flex; align-items: center; justify-content: center; z-index: 2; transition: all 0.2s; }
    .wishlist-btn:hover { background: #fff; transform: scale(1.1); }
    .product-image { width: 100%; aspect-ratio: 1; overflow: hidden; background: #f8f9fa; }
    .product-image img { width: 100%; height: 100%; object-fit: contain; transition: transform 0.4s; }
    .product-card:hover .product-image img { transform: scale(1.08); }
    .image-skeleton { width: 100%; height: 100%; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200% 100%; animation: loading 1.5s infinite; }
    @keyframes loading { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }
    .product-info { padding: 12px; display: flex; flex-direction: column; flex: 1; }
    .product-brand { color: #868e96; font-size: 12px; font-weight: 600; text-transform: uppercase; margin-bottom: 4px; }
    .product-desc { color: #2B2B2B; font-size: 0.8rem; margin-bottom: 0.75rem; line-height: 1.4; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; min-height: 2.2em; }
    .product-rating { display: flex; align-items: center; gap: 4px; font-size: 11px; margin-bottom: 10px; }
    .reviews { color: #868e96; }
    .product-footer { display: flex; justify-content: space-between; align-items: center; gap: 8px; margin-top: auto; }
    .product-price { display: flex; flex-direction: column; gap: 2px; flex: 1; }
    .old-price { color: #868e96; font-size: 11px; text-decoration: line-through; }
    .current-price { color: #E5332A; font-size: 16px; font-weight: 800; }
    .campaign-label { color: #E5332A; font-size: 8px; font-weight: 700; background: rgba(229, 51, 42, 0.1); padding: 2px 6px; border-radius: 3px; display: inline-block; margin-top: 2px; }
    .add-cart-btn { width: 36px; height: 36px; background: #E5332A; border: none; border-radius: 8px; color: #fff; display: flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; flex-shrink: 0; }
    .add-cart-btn:hover { background: #c72a22; transform: scale(1.1); }
    .add-cart-btn.in-cart { background: #06d6a0; }
    .add-cart-btn.adding { animation: pulse-btn 0.3s; }
    @keyframes pulse-btn { 50% { transform: scale(1.2); } }
    
    .banner-promo { margin: 56px 0; }
    .promo-content { background: linear-gradient(135deg, #2B2B2B, #1a1a1a); border-radius: 24px; padding: 48px; display: flex; justify-content: space-between; align-items: center; overflow: hidden; position: relative; }
    .promo-content::before { content: ''; position: absolute; top: -50%; right: -50%; width: 200%; height: 200%; background: radial-gradient(circle, rgba(229, 51, 42, 0.1), transparent 50%); animation: pulse 8s ease-in-out infinite; }
    .promo-text { color: #fff; max-width: 500px; position: relative; z-index: 1; }
    .promo-text h2 { font-size: 36px; margin-bottom: 12px; line-height: 1.2; }
    .promo-text p { font-size: 18px; opacity: 0.9; margin-bottom: 24px; line-height: 1.6; }
    .promo-details { display: flex; flex-wrap: wrap; gap: 12px; margin-bottom: 24px; }
    .promo-detail { display: flex; align-items: center; gap: 6px; background: rgba(255,255,255,0.1); padding: 6px 12px; border-radius: 8px; font-size: 13px; }
    .campaign-dots { display: flex; gap: 8px; margin-top: 16px; }
    .campaign-dots .dot { width: 10px; height: 10px; border-radius: 50%; background: rgba(255,255,255,0.3); border: none; cursor: pointer; transition: all 0.3s; }
    .campaign-dots .dot.active { background: #E5332A; width: 24px; border-radius: 5px; }
    .promo-image { width: 300px; height: 300px; flex-shrink: 0; position: relative; }
    .promo-circle { width: 100%; height: 100%; background: linear-gradient(135deg, #E5332A, #ff4436); border-radius: 50%; opacity: 0.2; animation: pulse 3s infinite; }
    .promo-icon { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: rgba(229, 51, 42, 0.3); }
    @keyframes pulse { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.1); } }
    
    .loading-state { text-align: center; padding: 80px 20px; }
    .spinner { width: 48px; height: 48px; border: 4px solid #e9ecef; border-top-color: #E5332A; border-radius: 50%; animation: spin 1s linear infinite; margin: 0 auto 16px; }
    @keyframes spin { to { transform: rotate(360deg); } }

    @media (max-width: 1200px) {
      .product-carousel-item { width: calc((100% - 60px) / 4); min-width: 200px; }
      .offers-grid { grid-template-columns: repeat(2, 1fr); }
      .carousel-nav-btn.left { left: -16px; }
      .carousel-nav-btn.right { right: -16px; }
    }

    @media (max-width: 992px) {
      .features-grid { grid-template-columns: repeat(2, 1fr); }
      .offers-grid { grid-template-columns: repeat(2, 1fr); }
      .product-carousel-item { width: calc((100% - 40px) / 3); min-width: 180px; }
      .carousel-nav-btn { width: 40px; height: 40px; }
      .carousel-nav-btn.left { left: -12px; }
      .carousel-nav-btn.right { right: -12px; }
    }

    @media (max-width: 768px) {
      /* Hero Slider Mobil Düzenlemeleri */
      .hero-slider { height: 380px; }
      .slide-content { padding: 0 8px; }
      .slide-content h1 { font-size: 22px; line-height: 1.2; margin-bottom: 10px; }
      .slide-content p { font-size: 13px; margin-bottom: 16px; line-height: 1.4; opacity: 0.95; }
      .slide-icon { font-size: 32px; margin-bottom: 12px; }
      .slide-icon svg { width: 32px; height: 32px; }
      .slide-discount { font-size: 11px; padding: 6px; 12px; margin-bottom: 12px; }
      .slide-threshold { font-size: 14px; padding: 6px; 12px; margin-bottom: 12px; border: 1.5px solid rgba(255,255,255,0.3) }
      .cta-btn { padding: 10px 20px; font-size: 13px; border-radius: 10px; }
      .slider-btn { width: 32px; height: 32px; }
      .slider-btn.prev { left: 8px; }
      .slider-btn.next { right: 8px; }
      .slider-dots { 
    bottom: 16px;
    gap: 8px;
  }
  
  .dot { 
    width: 8px; 
    height: 8px;
  }
  
  .dot.active { 
    width: 24px;
  }
      
      /* Kategori Bar Mobil */
      .category-bar { padding: 16px 0; }
      .cat-icon { width: 48px; height: 48px; font-size: 24px; }
      .cat-name { font-size: 11px; }
      
      /* Features Mobil */
      .features-grid { grid-template-columns: repeat(2, 1fr); gap: 12px; }
      .feature-card { padding: 16px; }
      .feature-icon { width: 48px; height: 48px; }
      .feature-text h4 { font-size: 13px; }
      .feature-text p { font-size: 11px; }
      
      /* Section Header Mobil */
      .section-header { 
        margin-bottom: 20px;
      }
      .section-title-with-icon { 
        gap: 12px;
        flex: 0 1 auto;
        max-width: calc(100% - 120px);
      }
      .section-icon { 
        width: 40px; 
        height: 40px;
      }
      .section-header h2 { 
        font-size: 20px;
      }
      .section-header p { 
        font-size: 11px;
      }
      .view-all { 
        padding: 8px 16px;
        font-size: 12px;
        margin-left: auto;
      }
      
      /* Kampanyalar Grid Mobil */
      .offers-grid { grid-template-columns: 1fr; gap: 16px; }
      .offer-content h3 { font-size: 16px; }
      .offer-content p { font-size: 12px; }
      .offer-icon { width: 48px; height: 48px; }
      
      /* Ürün Carousel Mobil */
      .product-carousel-item { 
        width: calc((100% - 20px) / 2);
        min-width: 150px;
        height: 320px;
      }
      .carousel-nav-btn { display: none; }
      .products-carousel { 
        -webkit-overflow-scrolling: touch;
        scroll-snap-type: x mandatory;
        gap: 12px;
      }
      .product-carousel-item {
        scroll-snap-align: start;
      }
      
      /* Ürün Kartı Mobil */
      .product-info { padding: 10px; }
      .product-brand { font-size: 10px; }
      .product-desc { 
        font-size: 11px;
        margin-bottom: 8px;
      }
      .product-rating { font-size: 10px; }
      .current-price { font-size: 14px; }
      .old-price { font-size: 10px; }
      .add-cart-btn { width: 32px; height: 32px; }
      .discount-badge { 
        font-size: 10px;
        padding: 3px 8px;
      }
      
      /* Banner Promo Mobil */
      .promo-content { 
        flex-direction: column;
        text-align: center;
        padding: 32px 20px;
      }
      .promo-text { max-width: 100%; }
      .promo-text h2 { 
        font-size: 24px;
        margin-bottom: 12px;
      }
      .promo-text p { 
        font-size: 14px;
        margin-bottom: 20px;
      }
      .promo-details { 
        justify-content: center;
        gap: 8px;
      }
      .promo-detail { 
        font-size: 11px;
        padding: 4px 8px;
      }
      .promo-image { 
        width: 180px;
        height: 180px;
        margin-top: 20px;
      }
      .promo-icon svg { 
        width: 60px;
        height: 60px;
      }
      
      /* Loading State Mobil */
      .loading-state { padding: 60px 20px; }
      .spinner { width: 40px; height: 40px; }
      .loading-state p { font-size: 14px; }
    }

    @media (max-width: 480px) {
      /* Küçük Mobil Cihazlar */
      .container { padding: 0 12px; }
      
      .hero-slider { height: 340px; }
      .slide-icon { 
    font-size: 28px; 
    margin-bottom: 8px;
  }
      .slide-icon svg {
    width: 28px;
    height: 28px;
  }
  
  .slide-discount { 
    font-size: 10px;
    padding: 5px 10px;
    margin-bottom: 8px;
  }
  
  .slide-threshold {
    font-size: 12px;
    padding: 5px 10px;
    margin-bottom: 8px;
  }
  
  .slide-content h1 { 
    font-size: 19px;
    margin-bottom: 8px;
  }
  
  .slide-content p { 
    font-size: 12px; 
    margin-bottom: 14px;
  }
  
  .cta-btn { 
    padding: 9px 18px; 
    font-size: 12px;
  }
  
  .slider-btn { display: none; }
      
      .section-header h2 { font-size: 18px; }
      .section-header p { font-size: 10px; }
      .view-all { 
        padding: 6px 12px;
        font-size: 11px;
      }
      
      .product-carousel-item { 
        width: calc((100% - 12px) / 2);
        min-width: 140px;
        height: 300px;
      }
      
      .feature-text h4 { font-size: 12px; }
      .feature-text p { font-size: 10px; }
      
      .promo-text h2 { font-size: 20px; }
      .promo-text p { font-size: 13px; }
      .promo-image { 
        width: 150px;
        height: 150px;
      }
      
      .cat-icon { width: 44px; height: 44px; font-size: 22px; }
      .cat-name { font-size: 10px; }
    }
  `}</style>;
}